import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import IndexRoute from './routes';
import { Provider } from "react-redux";
import { store } from "./redux/store";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <IndexRoute />
      </Provider>

    </div>
  );
}

export default App;
